import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.scss';

/**
 * A container that breaks up a list of content.
 * This is currently used on the order status page for listing out the order details
 * as well as for the skeleton when loading in the order details.
 */
export default function OrderStatusDetails({ children }) {
  return (
    <div className={styles['order-status-details']}>
      {React.Children.map(
        children,
        (detailContent) =>
          detailContent && (
            <div
              key={detailContent.key}
              className={classnames({
                [styles['hide-on-mobile']]: detailContent.props.hideonmobile,
                [styles['detail-card']]: !detailContent.props.nocard,
              })}
            >
              {detailContent}
            </div>
          ),
      )}
    </div>
  );
}

OrderStatusDetails.propTypes = {
  /**
   * Will render each child of the array of children as a separate block.
   * This means each child for children needs a `key` prop.
   */
  children: PropTypes.node.isRequired,
};
